module.exports = __webpack_public_path__ + "static/media/hu-HU.a7616273.md";